export function areAllElementsSame<T>(array: T[][]): boolean {
  if (array.length === 0 || array[0].length === 0) {
    return true; // Empty array is considered to have all elements the same
  }

  const firstElement = array[0][0];

  for (const row of array) {
    for (const element of row) {
      if (element !== firstElement) {
        return false;
      }
    }
  }

  return true;
}

export function apiUrl(){
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000';
  } else {
    return 'https://colorlink.jeanlouisle.com';
  }
}

export function devMode(){
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
}
